import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  email: string;
  roles: any[];
  currentRole: string | null;
  locationData: any[];
  userData: Record<string, any>;
  selectedBottler: any[];
  isSubmitted: boolean;
  location: any | null;
  submittedDataItem: any;
  selectedPlant: string[];
  apiCall: boolean;
}

const initialState: UserState = {
  email: "",
  roles: [],
  currentRole: sessionStorage.getItem("selectedRoleId"),
  locationData: [],
  userData: {},
  selectedBottler: [],
  isSubmitted: false,
  location: null,
  submittedDataItem: [],
  selectedPlant: [],
  apiCall :false
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setRoles: (state, action: PayloadAction<any[]>) => {
      state.roles = action.payload;
    },
    setCurrentRole: (state, action: PayloadAction<string | null>) => {
      state.currentRole = action.payload;
    },
    setLocation: (state, action: PayloadAction<any[]>) => {
      state.locationData = action.payload;
    },
    setUserData: (state, action: PayloadAction<Record<string, any>>) => {
      state.userData = action.payload;
    },
    setSelectedBottler: (state, action: PayloadAction<any[]>) => {
      state.selectedBottler = action.payload;
    },
    setIsSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isSubmitted = action.payload;
    },
     setSubmittedData: (state, action: PayloadAction<boolean>) => {
      state.submittedDataItem = action.payload;
    },
    setLocationDetails: (state, action: PayloadAction<any>) => {
      state.location = action.payload;
    },
    setSelectedPlant: (state, action: PayloadAction<string[]>) => {
      state.selectedPlant = action.payload;
    },
    setApiCall: (state, action: PayloadAction<boolean>) => {
      state.apiCall = action.payload;
    }
  },
});

export const {
  setEmail,
  setRoles,
  setCurrentRole,
  setLocation,
  setUserData,
  setSelectedBottler,
  setIsSubmitted,
  setLocationDetails,
  setSubmittedData,
  setSelectedPlant,
  setApiCall
} = userSlice.actions;
export default userSlice.reducer;
